<template>

    <v-container fluid class="ma-0 pa-0">

        <!-- Startup Registered (expande/collapse) -->
        <v-layout row wrap pa-2>
            <v-flex xs12 pa-3>
                <v-card>
                    <v-card-title class="primary white--text title">
                        <span class="headline">{{challenge.Title}}</span>
                        <v-spacer></v-spacer>
                        <v-card-actions>
                            <v-btn dark :disabled="completeStartups.length===0" icon @click="downloadExcel"><v-icon>mdi-download</v-icon></v-btn>
                        </v-card-actions>
                    </v-card-title>
                    <v-layout
                            justify-space-between
                            pa-3
                            row
                            wrap
                    >
                        <v-flex xs12 sm5 md5>
                            <v-treeview
                                    :items="items"
                                    :active.sync="active"
                                    activatable
                                    active-class="primary--text"
                                    open-on-click
                                    class="grey lighten-5"
                                    transition
                                    loading-icon="mdi-sync"
                            >
                                <template v-slot:prepend="{ item, active }">
                                    <v-icon
                                            v-if="!item.children"
                                            :color="active ? 'primary' : ''"
                                    >
                                        mdi-account
                                    </v-icon>
                                </template>
                            </v-treeview>
                        </v-flex>
                        <v-flex xs12 sm7 md7>
                            <v-layout d-flex fill-height align-center justify-center class="text-xs-center">
                                <v-scroll-y-transition mode="out-in">
                                    <v-flex pa-2>
                                        <div
                                                v-if="!selected"
                                                class="title grey--text text--lighten-1 font-weight-light"
                                                style="align-self: center;"
                                        >
                                            <span v-if="startupsBoolean">Select a Startup</span>
                                            <span v-else>No Startups Registered to this Challenge</span>
                                        </div>
                                        <v-card
                                                v-else
                                                :key="selected.id"
                                                class="pt-1 mx-auto full-height"
                                                flat
                                                pa-2
                                        >
                                            <v-card-text class="pa-2">
                                                <h3 class="headline mb-2">
                                                    {{ selected.name }}
                                                </h3>
                                                <div class="blue--text mb-1">{{ selected.contactDetails }}</div>
                                                <div class="blue--text subheading font-weight-bold mb-2">{{ selected.contactName }}</div>
                                                <v-divider></v-divider>
                                                <v-layout
                                                        row
                                                        wrap
                                                >
                                                    <v-flex xs12>
                                                        <v-layout column wrap align-center>
                                                            <v-flex ma-1 mt-2>
                                                                <strong>Market: </strong>{{selected.market}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-layout column wrap align-center>
                                                            <v-flex ma-1>
                                                                <strong>Website: </strong>
                                                                <a v-if="selected.website !== 'None'  &&  selected.website !== '' &&  selected.website !== '-'" :href="selected.website" target="_blank">{{selected.website}}</a>
                                                              <span v-else="selected.website !== 'None' &&  selected.website !== '' && selected.website !== '-'">{{selected.website}}</span>
                                                          </v-flex>
                                                      </v-layout>
                                                  </v-flex>
                                                  <v-flex xs12>
                                                      <v-layout column wrap align-center>
                                                          <v-flex ma-1>
                                                              <strong>Country: </strong>{{selected.country}}
                                                          </v-flex>
                                                      </v-layout>
                                                  </v-flex>
                                                  <v-flex xs12>
                                                      <v-layout column wrap align-center>
                                                          <v-flex ma-1>
                                                              Click <a style="text-decoration: underline;" @click="navigate('/iadmin/startupManagement/'+ selected.id)">here</a> for further details or click pdf icon to download the attachment
                                                          </v-flex>
                                                      </v-layout>
                                                  </v-flex>
                                                  <v-flex xs12>
                                                      <v-layout column wrap align-center>
                                                          <v-flex mt-3>
                                                              <v-avatar class="mb-2 clickable-cursor" size="50" tile @click="downloadFile">
                                                                  <v-img :src="require('@/assets/img/files/png/pdf.png')">
                                                                  </v-img>
                                                              </v-avatar>
                                                          </v-flex>
                                                      </v-layout>
                                                  </v-flex>

                                              </v-layout>
                                          </v-card-text>
                                      </v-card>
                                  </v-flex>
                              </v-scroll-y-transition>
                          </v-layout>
                      </v-flex>
                  </v-layout>
              </v-card>
          </v-flex>
      </v-layout>

  </v-container>


</template>

<script>
  import ExcelJS from 'exceljs';
  import FileSaver from 'file-saver';
  import RouterService from "@/helpers/RouterService";
  import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
  import TimeService from "@/helpers/TimeService";
  import UrlsService from "@/helpers/UrlsService";

  export default {
      name: "StartupRegisteredTreeView",
      props: {
          challenge: Object
      },
      data() {
          return {
              active: [],
              startups: [],
              completeStartups: [],
              startupsBoolean: false,
          }
      },
      created() {
      },
      computed: {
          items () {
              return this.startups
          },
          selected () {
              if (!this.active.length) return undefined
              const id = this.active[0]
              return this.startups.find(startup => startup.id === id)
          },
      },
      watch:{
          challenge(c){
              this.startups = []
              this.active = []
              if(c._id !== undefined) this.getStartups(c)
          }
      },
      methods: {
          downloadExcel(){
              let workbook = new ExcelJS.Workbook();
              let sheet = workbook.addWorksheet('Registered Startups');
              let columns = [];
              columns.push({header: "Area", key: "Area", width: 25})
              columns.push({header: "Name", key: "Name", width: 25})
              columns.push({header: "Country", key: "Country", width: 25})
              columns.push({header: "Region / city", key: "Region / city", width: 25})
              columns.push({header: "Contact name", key: "Contact name", width: 25})
              columns.push({header: "Contact details", key: "Contact details", width: 25})
              columns.push({header: "State of contact", key: "State of contact", width: 25})
              columns.push({header: "Idea description-EN", key: "Idea description-EN", width: 60})
              columns.push({header: "Idea description-IT", key: "Idea description-IT", width: 60})
              columns.push({header: "Addressed MU", key: "Addressed MU", width: 25})
              columns.push({header: "Technology area", key: "Technology area", width: 25})
              columns.push({header: "Vertical solution (if any)", key: "Vertical solution (if any)", width: 25})
              columns.push({header: "Idea state", key: "Idea state", width: 25})
              columns.push({header: "Patent", key: "Patent", width: 25})
              columns.push({header: "Replication complexity", key: "Replication complexity", width: 25})
              columns.push({header: "Deployment complexity", key: "Deployment complexity", width: 25})
              columns.push({header: "Technological footprint", key: "Technological footprint", width: 25})
              columns.push({header: "SDK/API", key: "SDK/API", width: 25})
              columns.push({header: "Business model", key: "Business model", width: 25})
              columns.push({header: "Extensive business enabler", key: "Extensive business enabler", width: 25})
              columns.push({header: "Funding status (CrunchBase)", key: "Funding status (CrunchBase)", width: 25})
              columns.push({header: "Evaluation date", key: "Evaluation date", width: 25})
              columns.push({header: "Financial status (Startuplus, iCRIBIS)", key: "Financial status (Startuplus, iCRIBIS)", width: 25})
              columns.push({header: "Opportunities", key: "Opportunities", width: 25} )
              columns.push({header: "Score", key: "Score", width: 25})
              columns.push({header: "BSL/MU contact", key: "BSL/MU contact", width: 25})
              columns.push({header: "Project state (if any)", key: "Project state (if any)", width: 25})
              columns.push({header: "Website", key: "Website", width: 25})
              columns.push({header: "Link to folder in Peers", key: "Link to folder in Peers", width: 60})
              columns.push({header: "Battlecard available", key: "Battlecard available", width: 25})
              columns.push({header: "Agreement", key: "Agreement", width: 25})
              columns.push({header: "Mobile phone", key: "Mobile phone", width: 25})
              columns.push({header: "Contact links", key: "Contact links", width: 25})
              columns.push({header: "Contact address", key: "Contact address", width: 25})
              columns.push({header: "Logo", key: "Logo", width: 25})
              columns.push({header: "Crunchbase link", key: "Crunchbase link", width: 25})
              columns.push({header: "Fundings amount", key: "Fundings amount", width: 25})
              columns.push({header: "Fundings date", key: "Fundings date", width: 25})
              columns.push({header: "Fundings investors", key: "Fundings investors", width: 25})
              columns.push({header: "Valuation", key: "Valuation", width: 25})
              columns.push({header: "Competitors", key: "Competitors", width: 25})
              columns.push({header: "SustainabilityGoals", key: "SustainabilityGoals", width: 25})
              columns.push({header: "Foundation", key: "Foundation", width: 25})
              columns.push({header: "NumberEmployees", key: "NumberEmployees", width: 25})
              columns.push({header: "UrlVideo", key: "UrlVideo", width: 25})
              columns.push({header: "Tags", key: "Tags", width: 25})

              sheet.columns = columns;
              for (let j = 0; j<this.completeStartups.length; j++){
                      if(this.completeStartups[j]['Tags'] != undefined && (this.completeStartups[j]['Tags'] instanceof Array)){
                          let tagString ="";
                          for(let z=0;z<this.completeStartups[j]['Tags'].length;z++){
                              tagString = tagString.concat(this.completeStartups[j]['Tags'][z])
                              if(z<this.completeStartups[j]['Tags'].length-1){
                                  tagString = tagString.concat(",")
                              }
                          }
                          this.completeStartups[j]['Tags'] = tagString
                      }

                if(this.completeStartups[j]['SustainabilityGoals'] != undefined && (this.completeStartups[j]['SustainabilityGoals'] instanceof Array) ){
                  let GoalsString ="";
                  for(let z=0;z<this.completeStartups[j]['SustainabilityGoals'].length;z++){
                    GoalsString = GoalsString.concat(this.completeStartups[j]['SustainabilityGoals'][z])
                    if(z<this.completeStartups[j]['SustainabilityGoals'].length-1){
                      GoalsString = GoalsString.concat(",")
                    }
                  }
                  this.completeStartups[j]['SustainabilityGoals'] = GoalsString
                }
                else if (this.completeStartups[j]['SustainabilityGoals'] == undefined) {
                  this.completeStartups[j]['SustainabilityGoals'] = ""
                }

                      this.completeStartups[j]['Score'] = parseFloat(this.completeStartups[j]['Score'])
                      if (this.completeStartups[j]['Mobile phone'] !== undefined) this.completeStartups[j]['Mobile phone'] = this.completeStartups[j]['Mobile phone'].toString()
                      sheet.addRow(this.completeStartups[j]);
              }

              sheet.getRow(1).font = {size: 12, bold: true, color: {argb: 'FFFFFFFF'}};
              sheet.getRow(1).eachCell(function(cell, colNumber) {
                      cell.fill = {
                          type: 'pattern',
                          pattern:'solid',
                          fgColor:{argb:'FF4169E1'},
                          bgColor:{argb:'FF4169E1'}
                      };
                  }
              )

              let borderStyles = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" }
              };

              sheet.eachRow({ includeEmpty: true },function(row, rowNumber) {
                  row.eachCell(function(cell, colNumber) {
                      cell.border = borderStyles;
                      cell.alignment = { wrapText: true };
                  });
              });

              workbook.xlsx.writeBuffer()
                  .then(buffer => FileSaver.saveAs(new Blob([buffer]), this.challenge.Title + ".xlsx"))
                  .catch(err => console.log('Error writing excel export', err))

          },
          navigate(path) {
              RouterService.goTo(path);
          },
          getStartups(c){
              let requestUrl = {
                  url: UrlsService.getStartupsRegisteredToChallenge,
                  timeout: TimeService.secondsToMillis(0),
              };
              let requestData = {
                  interactionData: {
                      challengeRequest: {
                          challenge: {
                              _id: c._id,
                          }
                      }
                  },
              };
              let requestObject = {
                  type: "normal",
                  urlsInfo: requestUrl,
                  data: {
                      data: requestData,
                  },
              };
              let messages = {
                  title: "List Startups",
                  loading: "Waiting for list of startups...",
                  error: "Cannot get startups...",
              };
              let options = {
                  loadingType: "fullscreen",
                  timeout: TimeService.secondsToMillis(0),
              };
              return APILoaderDecoratorService.setLoader(requestObject, messages, options)
                  .then(responseSuccess => {
                      this.startups = [];
                      let responseStartups = responseSuccess.response.startups;
                      this.completeStartups = responseStartups;
                      for (let i = 0; i < responseStartups.length; i++) {
                          this.startups.push({
                              id: responseStartups[i]["_id"],
                              name: responseStartups[i]["Name"],
                              country: responseStartups[i]["Country"],
                              contactName: responseStartups[i]["Contact name"],
                              contactDetails: responseStartups[i]["Contact details"],
                              market: responseStartups[i]["Addressed MU"],
                              website: responseStartups[i]["Website"],

                          });
                      }

                      if(responseStartups.length > 0) this.startupsBoolean = true;
                      else this.startupsBoolean = false;
                  });
          },
          downloadFile() {
              let requestUrl = {
                  url: UrlsService.getFileStartupRegisteredToChallenge,
                  timeout: TimeService.secondsToMillis(0),
              };
              let requestData = {
                  interactionData: {
                      challengeRequest: {
                          challenge: {
                              _id: this.challenge._id,
                          }

                      },
                      startupRequest: {
                          startup:{
                              _id: this.selected.id,
                          },
                      }
                  },
              };
              let requestObject = {
                  type: "normal",
                  urlsInfo: requestUrl,
                  data: {
                      data: requestData,
                  },
              };
              let messages = {
                  title: "Download Attachment",
                  loading: "Waiting for attachment downloading...",
                  error: "Cannot download attachment...",
              };
              let options = {
                  loadingType: "fullscreen",
                  timeout: TimeService.secondsToMillis(0),
              };
              APILoaderDecoratorService.setLoader(requestObject, messages, options)
                  .then(responseSuccess => {
                      let responseStartups = responseSuccess.response.file;

                      const base64Sourvce = responseStartups;
                      const downloadLink = document.createElement("a");
                      const fileName = this.selected.name + "_attachment.pdf";

                      downloadLink.href = base64Sourvce;
                      downloadLink.download = fileName;
                      document.body.appendChild(downloadLink);
                      downloadLink.click();
                  });
          },
      }

  }
</script>

<style scoped>
  .clickable-cursor{
      cursor: pointer;
  }

</style>